export default __webpack_public_path__ + "static/media/792.70ea6237.gif";